"use client";
import { jsx } from "react/jsx-runtime";
import { cn } from "../utils.js";
import * as __rspack_external_react from "react";
import * as __rspack_external__radix_ui_react_label_73c6aeea from "@radix-ui/react-label";
const Label = /*#__PURE__*/ __rspack_external_react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ jsx(__rspack_external__radix_ui_react_label_73c6aeea.Root, {
        ref: ref,
        className: cn('tw-text-neutral-light-800 tw-text-1.4 tw-font-semibold dark:tw-text-neutral-light-100', className),
        ...props
    }));
Label.displayName = __rspack_external__radix_ui_react_label_73c6aeea.Root.displayName;
export { Label };
